import { Icon, Text } from '@backyard-ui/core'
import { useState } from 'react'

import {
  ChevronUpRegular,
  ChevronDownRegular
} from 'scripts/react-components/shared/icons'

interface ArchivedButtonProps {
  text: string
  onClick?: () => void
}

const ArchivedButton = (props: Readonly<ArchivedButtonProps>) => {
  const { text, onClick } = props
  const [isOpen, setIsOpen] = useState(true)

  const handleClick = () => {
    setIsOpen(prev => !prev)
    if (onClick) onClick()
  }

  return (
    <button
      onClick={handleClick}
      className={`flex items-center ${isOpen ? 'text-gray-700' : 'text-green-700'}`}>
      <Text size="sm" weight="bold" color="current">
        {text}
      </Text>
      <Icon size="sm" UNSAFE_className="mt-0.5" color="current">
        {isOpen ? (
          <ChevronDownRegular data-testid="chevron-down" />
        ) : (
          <ChevronUpRegular data-testid="chevron-up" />
        )}
      </Icon>
    </button>
  )
}

export default ArchivedButton
